import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class DataCollectionEventService {


  static listDCE(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE,sort, regulationId ) {
    return HttpUtil.get(
      API_ROUTES.DATA_COLLECTION_EVENT.LIST
      .replace("<pageNumber>", pageNumber)
      .replace("<pageSize>", pageSize)
      
      .replace(
        regulationId ? "<regulationId>" : "&regulationId=<regulationId>",
        regulationId
      )
      .replace("<sort>", sort)
    );
  }
  
  static getDCE(id) {
    return HttpUtil.get(API_ROUTES.DATA_COLLECTION_EVENT.GET.replace("<id>", id));
  }

  static createDCE(payload) {
    return HttpUtil.post(API_ROUTES.DATA_COLLECTION_EVENT.CREATE, payload)
  }

  static updateDCE(id, payload) {
    return HttpUtil.put(
      API_ROUTES.DATA_COLLECTION_EVENT.UPDATE.replace('<id>', id),
      payload
    );
  }

  static shareDCE(id) {
    return HttpUtil.patch(API_ROUTES.DATA_COLLECTION_EVENT.SHARE.replace('<id>', id));
  }

  static getShareDetails(
    qId,
    pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
  ) {
    return HttpUtil.get(
      API_ROUTES.DATA_COLLECTION_EVENT.GET_SHARE_DETAILS
        .replace("<id>", qId)
        .replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
    );
  }
}
